import { LICENSE_TYPE } from '../../../../../../constants/LicenseConstant';
import { range } from '../../../../../../utils/ArrayUtils';

export const quantityOptions = range(1, 10).map((value) => ({ id: value, name: value }));
export const licenseTypeOptions = LICENSE_TYPE.map((license) => ({ id: license, name: license }));
